import { ref } from "vue";
import { ajaxRequest } from "~/services/ajax";

export const adminUserEmail = ref<string>("");

export async function getAdminEmail() {
	try {
		adminUserEmail.value = await ajaxRequest<string>("GET", "innosend_admin_email");
	} catch (error) {
		console.error("Error fetching data: ", error);
	}
}

// https://smeijer.github.io/leaflet-geosearch/providers/openstreetmap
